import React, { PropsWithChildren } from 'react';
import styled, { CSSObject } from '@emotion/styled';

import { WHITE, mq } from '@/ui-kit/theme';
import merge from 'lodash.merge';
import { Actions } from './actions';
import { Image } from './image';
import { Caption } from './caption';
import { DialogSize } from '../constants';
import { useDialogContext } from '../dialog-context';

interface IStyledBodyProps {
  size: DialogSize;
}

const StyledBody = styled.div<IStyledBodyProps>(({ size }) => {
  let styles: CSSObject = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    backgroundColor: WHITE,
    flexGrow: 1,
  };

  if (size === DialogSize.TINY) {
    const sizeStyles: CSSObject = {
      padding: '0 !important',

      [mq.xs]: { padding: '0 !important' },
    };

    styles = merge(styles, sizeStyles);
  }

  if (size === DialogSize.SMALL) {
    const sizeStyles: CSSObject = {
      padding: '24px !important',
      gap: '16px',

      [mq.xs]: { padding: '16px !important' },
    };

    styles = merge(styles, sizeStyles);
  }

  if (size === DialogSize.LARGE) {
    const sizeStyles: CSSObject = {
      padding: '32px !important',
      gap: '24px',

      [mq.xs]: {
        padding: '16px !important',
        gap: '16px',
      },
    };

    styles = merge(styles, sizeStyles);
  }

  return styles;
});

interface IBodyProps extends PropsWithChildren {
  className?: string;
}

export const Body = ({
  className,
  children,
}: IBodyProps) => {
  const { size } = useDialogContext();

  return (
    <StyledBody
      className={className}
      size={size}
    >
      {children}
    </StyledBody>
  );
};

Body.Caption = Caption;
Body.Actions = Actions;
Body.Image = Image;
